import { CommonModule } from '@angular/common'
import { Component, OnInit, inject } from '@angular/core'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatIconModule } from '@angular/material/icon'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { FooterComponent } from 'src/app/components/footer/footer.component'
import { HeaderComponent } from 'src/app/components/header/header.component'
import { ConfigurablePageComponent } from 'src/app/core/abstracts/configurable-page.component'
import { SeoService } from 'src/app/core/services/seo.service'

@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['../../../assets/page.scss', './page404.component.scss'],
  imports: [
    CommonModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatIconModule,
    HeaderComponent,
    FooterComponent,
  ],
})
export class Page404Component extends ConfigurablePageComponent implements OnInit {
  private _seoService = inject(SeoService)

  readonly pageTitle = $localize`:@@page.404.seo.title:Page Not Found`
  readonly pageDesc = $localize`:@@page.404.seo.description:Page Not Found`

  ngOnInit() {
    const config = this.globalDataService.config()
    this.pageConfig.set(this.globalDataService.config().page.page404)
    this._seoService.init(
      config.seo.data,
      {
        title: this.pageTitle,
        description: this.pageDesc,
      }
    )
  }
}
